import { render } from "./Hero.vue?vue&type=template&id=392a1684&scoped=true&bindings={}"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=392a1684&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-392a1684"

export default script